<template>
    <Base>
        <v-card-title class="text-center d-block">
            <span class="t-color-brand-medium-base">Login</span>
        </v-card-title>
        <v-card-text>
            <form
                :action="route('login.store')"
                id="formLogin"
                method="post"
            >
                <cp-csrf-token/>
                <v-text-field
                    label="E-mail"
                    name="email"
                    outlined
                    dense
                    required
                ></v-text-field>
                <v-text-field
                    label="Senha"
                    name="password"
                    outlined
                    dense
                    required
                    :append-icon="showPass ? '$eye' : '$eyeOff'"
                    :type="showPass ? 'text' : 'password'"
                    @click:append="showPass = !showPass"
                ></v-text-field>

                <div class="d-flex justify-end">
                    <cp-button
                        color="primary"
                        type="submit"
                        :disabled="saving"
                        :loading="saving"
                        @click="submit"
                    >
                        Logar
                    </cp-button>
                </div>
            </form>
        </v-card-text>
        <v-card-actions class="d-block text-right">
            <v-divider></v-divider>
            <a :href="route('password.request')" class="t-hint">Esqueceu sua senha?</a>
        </v-card-actions>
    </Base>
</template>

<script>
import Base from '@components/common/Base'

export default {
    data: () => ({
        saving: false,
        showPass: false
    }),

    metaInfo: () => ({
        title: 'Login'
    }),

    components: {
        Base
    },

    methods: {
        submit() {
            this.saving = true;
            document.querySelector('#formLogin').submit();
        },
    }
}
</script>